import { inject, Injectable, OnDestroy, signal } from "@angular/core";
import { NavigationStart, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { injectRequired } from 'src/app/infrastructure/functions/inject-required.function';

@Injectable({
    providedIn: 'root'
})
export class ReloadService 
    implements OnDestroy
{
    private __reloadSubscr: Subscription;
    
    private readonly _router = injectRequired(Router);

    isReload$$ = signal(true);

    constructor() {
        this._router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                this.isReload$$.set(false);
            }
        });
    }

    ngOnDestroy(): void {
        this.__reloadSubscr?.unsubscribe();
    }
}
